import { render, staticRenderFns } from "./newSubtle.vue?vue&type=template&id=51cbe654&scoped=true&"
import script from "./newSubtle.vue?vue&type=script&lang=js&"
export * from "./newSubtle.vue?vue&type=script&lang=js&"
import style0 from "./newSubtle.vue?vue&type=style&index=0&id=51cbe654&prod&scoped=true&lang=less&"
import style1 from "./newSubtle.vue?vue&type=style&index=1&id=51cbe654&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbe654",
  null
  
)

export default component.exports